import React, { Component } from 'react';

export default class BeforeDescription extends Component {
  render() {
    return (
      <section className='description'>
        <div className='description__bg-color'>
          <div className='description__content'>
            <section className='description__column description__column_left'>
              <header className='description__title description__title_small description__title_who'>
                КОМУ?
              </header>

              <ul className='description__list description__list_top'>
                <li className='description__list-item'>
                  Студентам профильных специальностей 1-2 курса (специалитет и&nbsp;бакалавриат), которые ни&nbsp;разу не&nbsp;были стажерами или сотрудниками IT-компании
                </li>
                <li className='description__list-item'>
                  Учащимся физ-мат школ, Школы программиста, участникам ШМИТ, ЛГМШ и&nbsp;НОУ &laquo;Поиск&raquo;
                </li>
                <li className='description__list-item'>
                  Школьникам 10-11&nbsp;классов, интересующихся программированием
                </li>
              </ul>
            </section>
            <section className='description__column description__column_right'>
              <header className='description__title description__title_small description__title_why'>
                ЗАЧЕМ?
              </header>

              <ul className='description__list description__list_bottom'>
                <li className='description__list-item'>
                  Получить представление об&nbsp;IT-индустрии, о&nbsp;настоящем, будущем и&nbsp;последних тенденциях
                </li>
                <li className='description__list-item'>
                  Узнать, в&nbsp;каких востребованных сферах&nbsp;IT можно развиваться
                </li>
                <li className='description__list-item'>
                  Познакомиться с&nbsp;омскими IT-компаниями, узнать о&nbsp;стажировках и&nbsp;карьерных перспективах
                </li>
                <li className='description__list-item'>
                  Завести знакомства с&nbsp;возможными работодателями и&nbsp;единомышленниками
                </li>
                <li className='description__list-item'>
                  Сделать осознанный выбор профессии
                </li>
              </ul>
            </section>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing/blocks/BeforeDescription.js